/**
 * Application Version Configuration
 * 
 * Update this version number when deploying new releases.
 * Format: MAJOR.MINOR.PATCH.BUILD
 * 
 * - MAJOR: Breaking changes or major feature releases
 * - MINOR: New features, backwards compatible
 * - PATCH: Bug fixes
 * - BUILD: Build number / hotfix
 */

export const APP_VERSION = '1.5.0.1';

// Optional: Build date for reference
export const BUILD_DATE = '2024-12-11';

